import {UntilDestroy} from '@ngneat/until-destroy';
import {Component} from '@angular/core';
import {ConfiguratorCartEntryInfoComponent} from '@spartacus/product-configurator/common';
import {CartItemContext} from '@spartacus/cart/base/root';
import {CartItemContextSource} from '@spartacus/cart/base/components';

@UntilDestroy()
@Component({
  selector: 'dcp-configurator-cart-entry-info',
  templateUrl: './dcp-configurator-cart-entry-info.component.html',
  styleUrls: ['./dcp-configurator-cart-entry-info.scss'],
  providers: [{provide: CartItemContext, useExisting: CartItemContextSource}],
})
export class DcpConfiguratorCartEntryInfoComponent extends ConfiguratorCartEntryInfoComponent {}
